<template>
    <a-locale-provider :locale="locale">
        <div id="app">
            <router-view/>
        </div>
    </a-locale-provider>
</template>
<style lang="less">
</style>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import router from './router.js'
    // import { AppDeviceEnquire } from '@/utils/mixin'
    export default {
        // mixins: [AppDeviceEnquire],
        data() {
            return {
                locale: zhCN
            }
        },
    }
</script>
<style>
    #app {
        height: 100%;
    }
</style>
